import React, { useEffect, useState } from "react";
import { ValidationMessage } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  FEED_POST_EDIT,
  FEED_POST_UPDATE,
  POSTS_CATEGORY_LIST_DROPDOWN,
} from "../../routes/routes";
import { toast } from "react-toastify";
import { LEAD_UPDATED } from "../../constant/constant";
import Select from "react-select";
import { FullPageLoader } from "../../components/common/Loader";
import { Image } from "react-bootstrap";
import { memberFormSelectStyles } from "../../constant/selectStyles";

const FeedPostEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [categoryOptions, setCategoryOptions] = useState([]);

  const submit = () => {
    setLoading(true);
    setBtnDisabled(true);
    const requestBody = {
      description: form.description,
      post_type: form.post_type,
    };
    if (form.post_image) {
      requestBody.post_image = form.post_image;
    }
    axios
      .put(FEED_POST_UPDATE + id, requestBody, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(LEAD_UPDATED);
          navigate("/feed-posts");
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          setErrors(err.response.data.error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  useEffect(() => {
    axios
      .get(FEED_POST_EDIT + id)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          const d = res.data.data;
          setForm({
            description: d.description || "",
            post_type: d.post_type,
            post_type_selected: d.post_type
              ? {
                  value: Number(d.post_type),
                  label: d.post_type_name,
                }
              : null,
            cardImage: d.post_image || "",
          });
        }
      })
      .finally(() => setLoading(false));

    axios.get(POSTS_CATEGORY_LIST_DROPDOWN).then((res) => {
      if (res.status === 200 && res.data.success) {
        setCategoryOptions(res.data.data || []);
      }
    });
  }, [id]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <h5 className="page-title">Lead</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/feed-posts"}>
                    <span>Leads List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Edit Lead</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/feed-posts"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center"></div>
              <div className="card-body app-form-fields">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="post_type">
                          Category<span className="text-danger">*</span>
                        </label>
                        <Select styles={memberFormSelectStyles}
                          name="post_type"
                          options={categoryOptions}
                          placeholder="Select Category"
                          value={form.post_type_selected || null}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              post_type: selected?.value,
                              post_type_selected: selected,
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="post_type" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="description">
                          Description<span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control"
                          id="description"
                          placeholder="Description"
                          rows={4}
                          value={form.description || ""}
                          onChange={(e) =>
                            setForm({ ...form, description: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="description" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="post_image">
                          Image
                        </label>
                        {form.cardImage && (
                          <div className="mb-2">
                            <a
                              href={form.cardImage}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <Image
                                src={form.cardImage}
                                width={100}
                                className="mt-1"
                              />
                            </a>
                          </div>
                        )}
                        <input
                          type="file"
                          className="form-control"
                          id="post_image"
                          name="post_image"
                          accept="image/*"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              post_image: e.target.files?.[0],
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="post_image" />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/feed-posts"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="button"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedPostEdit;
